import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import matchSorter from 'match-sorter';
import qs from 'querystring';
import * as propertyActions from '../../../actions/properties';
import * as sidebarActions from '../../../actions/sidebar';
import * as homePromoActions from '../../../actions/homePromos';
import Layout from '../../../layout';
import SearchBar from '../../../components/common/SearchBar';
import Input from '../../../components/common/Input';
import {
  Tabs,
  Tab,
  TabList,
  TabPill,
  TabPanel
} from '../../../components/common/Tabs';
import CheckboxList from '../../../components/common/List/CheckboxList';
import { ListItem, List } from '../../../components/common/List';

const propTypes = {
  hotel: PropTypes.object.isRequired,
  hotels: PropTypes.array.isRequired,
  homePromos: PropTypes.array.isRequired,
  fetchProperty: PropTypes.func.isRequired,
  fetchProperties: PropTypes.func.isRequired,
  fetchHomePromos: PropTypes.func.isRequired,
  updateSidebar: PropTypes.func.isRequired,
  cloneHomePromos: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

const Clone = ({
  hotel,
  hotels,
  homePromos,
  fetchProperties,
  fetchProperty,
  fetchHomePromos,
  updateSidebar,
  cloneHomePromos,
  match: {
    url,
    params: { hotelid }
  },
  location: { search },
  history
}) => {
  const [searchPromos, setSearchPromos] = useState('');
  const [searchHotels, setSearchHotels] = useState('');
  const [checked, setChecked] = useState({});
  const [promosChecked, setPromosChecked] = useState({});
  useEffect(() => {
    const { selected } = qs.parse(search.slice(1));
    if (selected) {
      setPromosChecked({
        ...promosChecked,
        [selected]: !promosChecked[selected]
      });
      history.replace(url);
    }
    fetchProperties({ per_page: 300 });
    fetchProperty(hotelid).then(property => {
      updateSidebar({ titles: { Hotel: property.name } });
    });
    fetchHomePromos(hotelid, { per_page: 1000 });
    return () => {};
  }, []);

  const onSubmit = evt => {
    evt.preventDefault();

    const ids = Object.keys(promosChecked)
      .map(v => {
        return promosChecked[v] ? v : undefined;
      })
      .filter(v => v);

    const toPropertyIds = Object.keys(checked)
      .map(v => {
        return checked[v] ? v : undefined;
      })
      .filter(v => v);

    if (!ids.length || !toPropertyIds.length) {
      // TODO alert or notification that both items and properties to clone to
      // must have at least one item checkd
      return;
    }

    cloneHomePromos(hotelid, ids, toPropertyIds).then(() => {
      history.push(`/hotels/${hotelid}/promos`);
    });
  };

  const filteredPromos = matchSorter(homePromos, searchPromos, {
    keys: ['title']
  });
  const currentPromos = filteredPromos.filter(promo => !promo.archived);
  const archivedPromos = filteredPromos.filter(promo => promo.archived);
  const filteredHotels = matchSorter(hotels, searchHotels, { keys: ['name'] });

  return (
    <Layout metaTitle="Clone a Home Promo">
      <div className="w-full max-w-3xl">
        <Link
          to={`/hotels/${hotelid}/promos`}
          className="mb-8 inline-block text-sm text-grey-dark hover:text-grey-darkest no-underline"
        >
          &lt; Back to Home Promos
        </Link>
        <h1 className="mb-6">Clone a Home Promo</h1>
        <div className="mb-16">
          Use this page to Clone Home Promos on {hotel.name}.
        </div>
        <div className="flex flex-wrap justify-between mb-16">
          <div style={{ width: 440 }}>
            <SearchBar
              id="filter-promos"
              className="mb-4"
              placeholder="Filter Home Promos..."
              value={searchPromos}
              onChange={({ value }) => setSearchPromos(value)}
            />
            <Tabs>
              <TabList>
                <Tab>
                  <span className="mr-2">Current</span>
                  <TabPill id="current-pill">{currentPromos.length}</TabPill>
                </Tab>
                <Tab>
                  <span className="mr-2">Archived</span>
                  <TabPill id="archived-pill">{archivedPromos.length}</TabPill>
                </Tab>
              </TabList>

              <TabPanel>
                <List id="current-list">
                  {currentPromos.map(promo => (
                    <ListItem
                      id={promo.id}
                      key={promo.id}
                      className="p-4 border-b border-grey-light flex items-center"
                    >
                      <Input
                        id={promo.id}
                        type="checkbox"
                        className="mr-4"
                        input={{
                          checked: !!promosChecked[promo.id],
                          onChange: () =>
                            setPromosChecked({
                              ...promosChecked,
                              [promo.id]: !promosChecked[promo.id]
                            })
                        }}
                      />
                      <Link to={`/hotels/${hotelid}/promos/${promo.id}/edit`}>
                        {promo.title}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </TabPanel>
              <TabPanel>
                <List id="archived-list">
                  {archivedPromos.map(promo => (
                    <ListItem
                      id={promo.id}
                      key={promo.id}
                      className="p-4 border-b border-grey-light flex items-center"
                    >
                      <Input
                        id={promo.id}
                        type="checkbox"
                        className="mr-4"
                        input={{
                          checked: !!promosChecked[promo.id],
                          onChange: () =>
                            setPromosChecked({
                              ...promosChecked,
                              [promo.id]: !promosChecked[promo.id]
                            })
                        }}
                      />
                      <Link to={`/hotels/${hotelid}/promos/${promo.id}/edit`}>
                        {promo.title}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </TabPanel>
            </Tabs>
          </div>
          <div style={{ width: 440 }}>
            <SearchBar
              id="filter-hotels"
              className="mb-16"
              placeholder="Filter Hotels..."
              value={searchHotels}
              onChange={({ value }) => setSearchHotels(value)}
            />
            <CheckboxList
              id="checkbox-hotels"
              title="Hotels"
              data={filteredHotels.map(hotelItem => ({
                id: hotelItem.id,
                name: hotelItem.name,
                displayName: item => (
                  <Link to={`/hotels/${item.id}`} className="mr-4">
                    {item.name}
                  </Link>
                ),
                checked: checked[hotelItem.id],
                onChange: () => {
                  setChecked({
                    ...checked,
                    [hotelItem.id]: !checked[hotelItem.id]
                  });
                }
              }))}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <button type="button" className="btn" onClick={onSubmit}>
            Clone
          </button>
        </div>
      </div>
    </Layout>
  );
};

Clone.propTypes = propTypes;

export default connect(
  (state, props) => ({
    hotel: state.property.data,
    // FIXME
    hotels: state.properties.data.filter(property => property.type === 'hotel'),
    homePromos: state.homePromos.data,
    isLoading:
      state.property.isLoading ||
      state.properties.isLoading ||
      state.homePromos.isLoading
  }),
  {
    ...propertyActions,
    ...homePromoActions,
    ...sidebarActions
  }
)(Clone);
